/*
Copyright (c) 2012-2023 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import { isDev, isStg } from "constants/domain"
import { MENUS } from "constants/routes"
import React, { useEffect } from "react"
import { Route, RouteProps } from "react-router"
import { getUCMConfig, UCMConfigKey } from "utils/config"
import { TroyWebTracker } from "utils/tracking"
import { EventAction, EventCategory } from "constants/tracking"
import styles from "./styles.modules.css"

export interface FlaggedRouteProps extends RouteProps {
  flag?: UCMConfigKey | boolean
  env?: "development" | "staging"
}

const NotFoundPage = () => {
  useEffect(() => {
    TroyWebTracker.sendEvent({
      category: EventCategory.notFoundPage,
      action: EventAction.pageLoad,
    })
  }, [])

  const redirect = () => {
    const url = isDev() ? MENUS : "/"

    TroyWebTracker.sendEvent({
      category: EventCategory.notFoundPage,
      action: EventAction.redirectToHome,
      labels: {
        REDIRECT_TO: url,
      },
    })
    window.location.href = url
  }

  return (
    <div data-testid="not-found">
      <div className={styles.notFoundPage}>
        No Data Found <a onClick={redirect}>Go back to home Page</a>
      </div>
    </div>
  )
}

export const NotFoundRoute = () => <Route component={NotFoundPage} />

function FlaggedRoute({ flag, env, ...restOfProps }: FlaggedRouteProps) {
  if (env === "staging" && !isDev() && !isStg()) {
    return <NotFoundRoute />
  }
  if (env === "development" && !isDev()) {
    return <NotFoundRoute />
  }
  if (typeof flag === "string" && !getUCMConfig(flag)) {
    return <NotFoundRoute />
  }
  if (typeof flag === "boolean" && !flag) {
    return <NotFoundRoute />
  }
  return <Route {...restOfProps} />
}

export default FlaggedRoute
